<template>
  <header
    id="header"
    class="header sticky-top border-bottom bg-white py-3 py-md-4"
  >
    <div class="container-fluid" >
      <nav class="navbar navbar-expand-lg py-0 adjust-m" >
        <div
          class="fw-bold py-0 me-lg-5"
          style="text-decoration: none !important;"
        >
          <router-link to="/" class="text-decoration-none">
            <div v-if="!is_theme_dark" class="d-flex align-items-center gap-3">
              <img
                class="header-logo"
                src="@/assets/img/rent-ease-logo.png"
                alt="RentalRave Logo"
              />
              <h4 class="d-none d-lg-block fw-bold mb-0">
                <span style="color: #012035">Rent</span>
                <span style="color: #1eacff;">Ease</span>
              </h4>
            </div>
            <div v-else class="d-flex align-items-center gap-3">
              <img
                class="header-logo"
                src="@/assets/img/rent-ease-logo.png"
                alt="RentalRave Logo"
              />
              <h4 class="d-none d-lg-block fw-bold mb-0">
                <span style="color: #fff">Rent</span
                ><span style="color: #1eacff;">Ease</span>
              </h4>
            </div>
          </router-link>
        </div>
        <div class="d-flex align-items-center gap-4 gap-lg-5 ms-lg-auto">
          <!-- <router-link class="nav-link" to="/help">Help Center</router-link> -->
          <h6 v-if="userName != null">{{userName}}</h6>
          <div class="d-flex align-items-center gap-3">
            <div class="d-flex gap-2">
              <button
                @click="toggleTheme()"
                type="button"
                class="btn btn-default btn-icon rounded-circle"
              >
                <i v-if="is_theme_dark" class="fas fa-sun"></i>
                <i v-else class="fas fa-moon"></i>
              </button>
            </div>
            <div class="vr my-auto"></div>
            <!-- <button
              @click.prevent="ifRegistered()"
              type="button"
              class="btn btn-default btn-icon rounded-circle"
            >
              <i class="fas fa-user"></i>
            </button> -->
            <div class="dropdown" >
              <button
                type="button"
                class="btn btn-default btn-icon rounded-circle dropdown-toggle"
                data-bs-toggle="dropdown" aria-expanded="false"
              >
                <i class="fas fa-bars"></i>
              </button>
              <ul class="dropdown-menu dropdown-menu-lg-end">
                <!-- <li v-if="userEmail == null"><a class="dropdown-item"  @click="toggleAuth()">Login</a></li> -->
                <li v-if="userEmail == null"><a class="dropdown-item"  @click="showLoginModal()">Login</a></li>
                <li><a class="dropdown-item"  @click="showRegistrationModal()">Register</a></li>
              </ul>
            </div>
          </div>
        </div>
      </nav>
    </div>

    <!-- <div
      class="auth-backdrop"
      @click="toggleAuth()"
      :class="{ hidden: is_auth_hidden }"
    ></div>
    <div class="auth bg-white" :class="{ hidden: is_auth_hidden }">
      <div class="card">
        <div class="card-body bg-white sticky-top p-4">
          <div
            class="fw-bold d-flex justify-content-between align-items-center mb-0"
          >
            <h5 class="fw-bold mb-0">Account</h5>
            <a
              href="#"
              role="button"
              class="btn btn-default btn-icon rounded-circle"
              @click.prevent="toggleAuth()"
              ><i class="fas fa-times text-dark"></i
            ></a>
          </div>
        </div>

        <Authentication  @closeModal="is_auth_hidden =false" :modalData="authenticationModalData" />
      </div>
    </div> -->
  </header>
</template> 

<script>
// import Authentication from "@/components/Authentication.vue";

export default {
  name: "HeaderNavigation",
  // components: {
  //   Authentication,
  // },
  data: () => ({
    is_theme_dark: false,
    is_auth_hidden: true,
    is_mobile_number_verified: false,
    is_otp_verified: false,
    is_for_registration: false,
    is_otp_invalid: false,

    mobile_number: "",
    user_id: "",
    one_time_pin: "",
    first_name: "",
    last_name: "",
    userEmail: "",
    userName:"",
    authenticationModalData:[]
  }),
  mounted() {
    this.userEmail = localStorage.getItem("userEmail");
    this.userName = localStorage.getItem("userName");
    if (localStorage.getItem("_theme") === null) {
      localStorage.setItem("_theme", "light");
    } else {
      if (localStorage.getItem("_theme") == "light") {
        this.is_theme_dark = false;
        $("#app").removeClass("dark");
      } else {
        this.is_theme_dark = true;
        $("#app").addClass("dark");
      }
    }
    if (this.$route.query.exp != null && this.$route.query.email != null) {
      this.is_auth_hidden = false;
    }
  },
  updated() {
    if (this.is_auth_hidden === false) {
      $("#body").addClass("overflow-hidden");
    } else {
      $("#body").removeClass("overflow-hidden");
    }
  },
  methods: {
    toggleTheme() {
      if (this.is_theme_dark == true) {
        localStorage.setItem("_theme", "light");
        $("#app").removeClass("dark");
        this.is_theme_dark = false;
      } else {
        localStorage.setItem("_theme", "dark");
        $("#app").addClass("dark");
        this.is_theme_dark = true;
      }
    },
    toggleAuth() {
      if (this.is_auth_hidden === false) {
        console.log("sample")
        $("#body").addClass("overflow-hidden");
        this.is_auth_hidden = true;
        this.authenticationModalData = {dialog:this.is_auth_hidden}
      } else {
        console.log("test")
        $("#body").removeClass("overflow-hidden");
        this.is_auth_hidden = false;
        this.authenticationModalData = {dialog:this.is_auth_hidden}
      }
    },
    toggleSearch() {
      $(".search-block").toggleClass("hidden");
      $(".search-block-backdrop").toggleClass("hidden");
      $("#body").toggleClass("overflow-hidden");
    },
    showRegistrationModal() {
      $(function () {
        $("#registrationModal").modal("show");
      });
    },
    showLoginModal() {
      $(function () {
        $("#loginModal").modal("show");
      });
    },
  },
};

</script>
